import { CATEGORY_LIST, CATEGORIES } from "@/lib/leadMeta";

export const TypeLegend = ({ className = "", onSelect, active = [] }) => (
  <div className={`flex flex-wrap items-center gap-x-2 gap-y-1 ${className}`} data-testid="type-legend">
    {CATEGORY_LIST.map((k) => {
      const c = CATEGORIES[k];
      const on = active.includes(k);
      const clickable = typeof onSelect === "function";
      const inner = (
        <>
          <span className="h-2 w-2 rounded-full" style={{ backgroundColor: c.color }} />
          <span className={on ? "font-semibold" : "text-muted-foreground"} style={{ color: on ? c.color : undefined }}>{c.label}</span>
        </>
      );
      if (!clickable) {
        return <span key={k} data-testid={`legend-${k}`} className="inline-flex items-center gap-1 text-[11px]">{inner}</span>;
      }
      return (
        <button key={k} type="button" onClick={() => onSelect(k)} data-testid={`legend-filter-${k}`}
          className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] transition-colors hover:bg-white/10 ${on ? "bg-white/10" : ""}`}
          title={`Show only ${c.label} leads`}>
          {inner}
        </button>
      );
    })}
  </div>
);
